import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { TableComponent } from 'src/app/@generic-table-app/components/table.component';
import { FormBusquedaConsultaComponent } from '../@components/form-busqueda-consulta/form-busqueda-consulta.component';
import { TableItems } from 'src/app/@generic-table-app/clases/table-items';
import { delay, of, Subscription, take } from 'rxjs';
import { AppState } from 'src/app/@store/app.reducers';
import { Store } from '@ngrx/store';
import { ActivarLoadingAction, DesactivarLoadingAction, MostrarMensajeAvisoAction, MostrarMensajeErrorAction } from 'src/app/@store/actions';
import { Router } from '@angular/router';
import { ModalBuscarSiniestroComponent } from '../@modals/modal-buscar-siniestro/modal-buscar-siniestro.component';
import { MatDialog } from '@angular/material/dialog';
import { EstatusSiniestrosComplementoComponent } from 'src/app/@generic-table-app/components/complemento-web/estatus-siniestro-complemento.component';
import { ComplementoWebService } from 'src/app/services/complemento-web/complemento-web.service';
import { ModalVerResumenSiniestroComponent } from '../@modals/modal-ver-resumen-siniestro/modal-ver-resumen-siniestro.component';
import { SiniestroComplemento, ConsultaSiniestroOutput } from 'src/app/models/complementos-web/complementos-web.model';
import { ProcesosComunesComplementoService } from 'src/app/services/complemento-web/procesos-comunes-complemento.service';
import { ResultApiResponse } from 'src/app/models/complementos-web/complementos-web-servicios.model';
import moment from 'moment';
import { MatCard, MatCardContent } from '@angular/material/card';
import { MatButton } from '@angular/material/button';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';

import { TableComponent as TableComponent_1 } from '../../../@generic-table-app/components/table.component';

@Component({
    selector: 'app-consulta-principal',
    templateUrl: './consulta-principal.component.html',
    styleUrls: ['./consulta-principal.component.scss'],
    imports: [MatCard, MatCardContent, FormBusquedaConsultaComponent, MatButton, MatMenuTrigger, MatMenu, MatMenuItem, TableComponent_1]
})
export class ConsultaPrincipalComponent implements AfterViewInit {

  @ViewChild(TableComponent) private myAppTable: TableComponent;
  @ViewChild('refFormBdqSiniestros') refFormBdqSiniestros: FormBusquedaConsultaComponent;

  public muestraGrid: boolean = false;
  public datatable: Array<any> = [];

  public siniestros: any[];

  eventData = ConsultaPrincipalComponent;

  public options: any = {
    stack: true, rowSelection: false,
    lazyLoad: false, numberOfRows: 10, exportExcelComponente: true,
    herramientasTabla: 'mini', rowSelectionAllowMultiple: false, rowSelectionInitialState: false
  };

  public columnas: Array<TableItems> = [
    { name: 'Siniestro', id: 'num_siniestro', renderItem: 'num_siniestro', renderText: 'toUppercase' },
    { name: 'Estatus MBS', id: 'desc_estatus_mbs', componentItem: EstatusSiniestrosComplementoComponent, export: false },
    { name: 'F. Estatus', id: 'fec_reg_folio_mbs' },
    { name: 'H. Estatus', id: 'hora_reg_folio_mbs' },
    { name: 'Estado', id: 'desc_estado' },
    { name: 'Población', id: 'desc_municipio' },
    { name: 'Ajustador', id: 'desc_ajustador' },
    { name: 'Registrado', id: 'fecreg' },
    { name: 'H. Avi', id: 'horareg' },
    { name: 'Operador', id: 'nomb_operador' },
    { name: 'Teléfono', id: 'tel_asegurad' },
    { name: 'Causa', id: 'desc_causa' },
    {
      name: '', id: 'AbrirConsulta', export: false, click: 'AbrirConsulta',
      renderItem: { tipo: 'a', texto: 'Abrir', clase: 'botonTabla' }
    },
  ];

  public listObservables: Array<Subscription> = [];

  constructor(
    private store: Store<AppState>,
    private router: Router,
    private dialog: MatDialog,
    private complementoWebService: ComplementoWebService,
    private procesosComunesService: ProcesosComunesComplementoService
  ) {
  }

  ngAfterViewInit(): void {
    if (sessionStorage.getItem("siniestro-complemento")) {
      // this.ejecutarBusquedaModalIndividual(JSON.parse(sessionStorage.getItem("siniestro-complemento")));
      sessionStorage.removeItem('siniestro-complemento');
    }
  }

  onTableSearch(): any {
    return of(this.datatable).pipe(delay(200));
  }

  trigger($event) {
    if ($event.name === 'AbrirConsulta') {
      sessionStorage.setItem('siniestro-complemento', JSON.stringify($event.value.changedRow));
      this.consultarSiniestro($event.value.changedRow);
    }
  }

  consultarSiniestros() {
    const request = {
      oficina: this.refFormBdqSiniestros.formSiniestrosConsulta.getRawValue()?.idOficina ? this.refFormBdqSiniestros.formSiniestrosConsulta.getRawValue()?.idOficina : null,
      fechaInicio: this.refFormBdqSiniestros.formSiniestrosConsulta.getRawValue()?.fechaRegistroInicial ? moment(this.refFormBdqSiniestros.formSiniestrosConsulta.getRawValue()?.fechaRegistroInicial).format("DD/MM/YYYY") : null,
      fechaTermino: this.refFormBdqSiniestros.formSiniestrosConsulta.getRawValue()?.fechaRegistroFinal ? moment(this.refFormBdqSiniestros.formSiniestrosConsulta.getRawValue()?.fechaRegistroFinal).format("DD/MM/YYYY") : null,
      estatus: this.refFormBdqSiniestros.formSiniestrosConsulta.getRawValue()?.idEstatus ? this.refFormBdqSiniestros.formSiniestrosConsulta.getRawValue()?.idEstatus : null,
      limite: 1800,
      registrosPagina: 0,
      consecutivo: null,
      tipoBusqueda: 1,
      oficinak: null,
      aak: null
    }
    this.store.dispatch(ActivarLoadingAction());
    this.complementoWebService.consultaSiniestros(request).subscribe({
      next: (value) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.datatable = value.Resultado.Siniestros;
        this.myAppTable.execute();
      },
      error: (err) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos obtener los datos.' }));
        this.datatable = [];
        this.myAppTable.execute();
      },
    })
  }

  consultarSiniestro(siniestro: SiniestroComplemento) {
    const request = {
      moneda: siniestro.monedak,
      ramo: siniestro.ramok,
      sramo: siniestro.sramok,
      oficina: siniestro.oficinak,
      consecutivo: siniestro.conseck,
      anio: siniestro.aak,
      siniestroCompleto: `${siniestro.monedak}-${siniestro.ramok}-${siniestro.sramok}-${siniestro.oficinak}-${siniestro.conseck}-${siniestro.aak}`,
    }

    this.store.dispatch(ActivarLoadingAction());
    this.complementoWebService.consultaSiniestro(request).subscribe({
      next: (result) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.procesaDetalleComplemento(siniestro, result);
      },
      error: (err) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos obtener los datos.' }));
      },
    })
  }

  procesaDetalleComplemento(siniestroConsulta: SiniestroComplemento, siniestroDetalle: ResultApiResponse<ConsultaSiniestroOutput>) {
    if (siniestroDetalle.Exito) {
      if (siniestroDetalle.Resultado.Siniestro ? siniestroDetalle.Resultado.Siniestro[0] != null : false) {
        if (siniestroDetalle.Resultado.Siniestro[0].estatus == 4) {
          const perfilAdmin = siniestroDetalle.Resultado.perfil_administrador
          const responsabilidadSiniestro = [3, 6].includes(siniestroDetalle.Resultado.Siniestro[0].causa) && Number(perfilAdmin) == 0 ? 2 : siniestroDetalle.Resultado.Siniestro[0].respons_sini;
          const detalleSiniestro = {
            estatus: siniestroDetalle.Resultado.Siniestro[0].estatus,
            perfil: siniestroDetalle.Resultado.perfil,
            perfilAdministrador: perfilAdmin,
            siniestroDetalle: siniestroDetalle.Resultado.Siniestro,
            causa: siniestroDetalle.Resultado.Siniestro[0].causa,
            responsabilidad: responsabilidadSiniestro,
            siniestroCompleto: `${siniestroConsulta.monedak}-${siniestroConsulta.ramok}-${siniestroConsulta.sramok}-${siniestroConsulta.oficinak}-${siniestroConsulta.conseck}-${siniestroConsulta.aak}`,
          }
          this.router.navigate(['/complemento-web/consulta/detalle', detalleSiniestro.siniestroCompleto]);
        } else {
          this.abrirModalResumenSiniestro(siniestroConsulta, siniestroDetalle.Resultado);
        }
      } else {
        this.procesosComunesService.alertaGeneralComplemento('Aviso', 'No se encontró información del siniestro seleccionado.', 'info', false, true);
      }
    } else {
      this.procesosComunesService.alertaGeneralComplemento('Aviso', `${siniestroDetalle.Mensaje}`, 'info', false, true);
    }
  }

  exportarExcel() {
    if (this.myAppTable['Table']['data']['exportData'].length > 0) {
      this.myAppTable.exportToExcel();
    } else {
      this.store.dispatch(MostrarMensajeAvisoAction({ titulo: 'Aviso', mensaje: 'No cuenta con datos para exportar.' }))
    }
  }

  abrirModalAccion(accion: string) {
    if (accion == 'individual') {
      this.abrirModalBusquedaIndividual();
    }
  }

  abrirModalBusquedaIndividual() {
    const dialog = this.dialog.open(ModalBuscarSiniestroComponent, {
      width: '450px',
      height: 'auto',
      closeOnNavigation: true,
      hasBackdrop: true,
      disableClose: true,
      data: {},
    }).afterClosed().pipe(take(1)).subscribe(data => {
      if (data != undefined) {
        this.ejecutarBusquedaModalIndividual(data);
      }
    });
  }

  abrirModalResumenSiniestro(siniestro, siniestroDetalle: ConsultaSiniestroOutput) {
    const dialog = this.dialog.open(ModalVerResumenSiniestroComponent, {
      width: '1800px',
      height: 'auto',
      closeOnNavigation: true,
      hasBackdrop: true,
      disableClose: true,
      data: { siniestro, siniestroDetalle, fechasDetalle: this.refFormBdqSiniestros.detalleFechasBusqueda },
    }).afterClosed().pipe(take(1)).subscribe(data => {

    });
  }

  ejecutarBusquedaModalIndividual(data: SiniestroComplemento | any) {
    this.refFormBdqSiniestros.formSiniestrosConsulta.patchValue({
      sucursal: data?.sucursal ?? data?.oficinak,
      consecutivo: data?.consecutivo ?? data?.conseck,
      anio: data?.anio ?? data?.aak,
    });
    const request = {
      oficina: null,
      fechaInicio: null,
      fechaTermino: null,
      estatus: null,
      limite: 1800,
      registrosPagina: 0,
      consecutivo: this.refFormBdqSiniestros.formSiniestrosConsulta.getRawValue()?.consecutivo ? this.refFormBdqSiniestros.formSiniestrosConsulta.getRawValue()?.consecutivo : null,
      tipoBusqueda: 2,
      oficinak: this.refFormBdqSiniestros.formSiniestrosConsulta.getRawValue()?.sucursal ? this.refFormBdqSiniestros.formSiniestrosConsulta.getRawValue()?.sucursal : null,
      aak: this.refFormBdqSiniestros.formSiniestrosConsulta.getRawValue()?.anio ? this.refFormBdqSiniestros.formSiniestrosConsulta.getRawValue()?.anio : null
    }
    this.store.dispatch(ActivarLoadingAction());
    this.complementoWebService.consultaSiniestros(request).subscribe({
      next: (value) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.datatable = value.Resultado.Siniestros;
        if (this.datatable.length == 0) {
          this.procesosComunesService.alertaGeneralComplemento('Aviso', `No se encontró ningún registro con la busqueda indicada.`, 'warning', false, true);
        }
        this.myAppTable.execute();
      },
      error: (err) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos obtener los datos.' }));
        this.datatable = [];
        this.myAppTable.execute();
      },
    })
  }

}
